import { render, staticRenderFns } from "./BindImport.vue?vue&type=template&id=3a41fecf&scoped=true"
import script from "./BindImport.vue?vue&type=script&lang=js"
export * from "./BindImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41fecf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a41fecf')) {
      api.createRecord('3a41fecf', component.options)
    } else {
      api.reload('3a41fecf', component.options)
    }
    module.hot.accept("./BindImport.vue?vue&type=template&id=3a41fecf&scoped=true", function () {
      api.rerender('3a41fecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/lists/BindImport.vue"
export default component.exports